l = require 'lib/localize'
t = require('views/internal/recup-with-helpers')('org_account')
AddToEnterpriseComponent = require 'views/organization/add-to-enterprise-component'
AddToEnterprisePopoverComponent = require 'views/organization/add-to-enterprise-popover-component'
ApiError = require 'network/api-error'
BoardCreateVisibilityRestrictionsComponent = require 'views/organization/board-create-visibility-restrictions-component'
BoardInviteRestrictionsComponent = require 'views/organization/board-invite-restrictions-component'
OrgBCSettingsComponent = require 'views/organization/org-bc-settings-component'
OrgInviteRestrictionsComponent = require 'views/organization/org-invite-restrictions-component'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
React = require 'react'
ReactDOM = require 'react-dom'
SettingSectionComponent = require 'views/organization/setting-section-component'
SlackComponent = require 'views/organization/slack-component'
SlackRestrictionsComponent = require 'views/organization/slack-restrictions-component'
VisibilityComponent = require 'views/organization/visibility-component'

SETTINGS =
  boardVisibilityRestrictions: ['boardVisibilityRestrict.private', 'boardVisibilityRestrict.org', 'boardVisibilityRestrict.public']
  orgInviteRestrict: ['orgInviteRestrict']
  externalMembersDisabled: ['externalMembersDisabled']
  permissionLevel: ['permissionLevel']

module.exports = class extends React.Component
  constructor: (props) ->
    super(props)
    @state = {
      joinRequest: undefined
      dataHasLoaded: false
    }

  displayName: 'OrgAccountComponent'

  componentDidMount: ->
    @props.team.getEnterpriseJoinRequest()
    .then (joinRequest) =>
      @setState({ dataHasLoaded: true, joinRequest })

  render: t.renderable ->
    if !@state.dataHasLoaded
      t.div '.team-join-enterprise-request', ->
        t.div '.spinner'
    else
      t.div =>
        if @props.currentMember.enterpriseList.length > 0
          t.addElement @getAddToEnterpriseComponent()
        t.addElement @getVisibilitySection()

        if @props.hasBC
          t.addElement @getBCSettingsComponent()
          t.addElement @getSlackSection()
        else
          t.addElement @getSlackSection()
          t.addElement @getBCSettingsComponent()

  getAddToEnterpriseComponent: ->
    React.createElement AddToEnterpriseComponent,
      isAdmin: @props.isAdmin
      enterprise: @props.team.getEnterprise()
      joinRequest: @state.joinRequest
      currentMember: @props.currentMember
      canChange: !@props.team.getEnterprise()? && @props.isAdmin
      onRequestClick: (el) =>
        PopOver.toggle
          elem: el
          getViewTitle: -> l(['view title', 'add-to-enterprise'])
          reactElement: React.createElement AddToEnterprisePopoverComponent,
            key: "add-to-enterprise"
            member: @props.currentMember
            onClick: (enterprise) =>
              PopOver.hide()

              # Trigger a re-render with a stub joinRequest so we don't have to
              # wait for the real one.
              @setState
                joinRequest:
                  member: @props.currentMember
                  enterprise: enterprise

              @props.team.requestToJoinAnEnterprise(enterprise)
                .then (joinRequest) =>
                  @setState({ joinRequest })
        return
      onCancelClick: =>
        @setState({ joinRequest: undefined })
        @props.team.cancelEnterpriseJoinRequest()

  getVisibilitySection: ->
    React.createElement SettingSectionComponent,
      header: t.render -> t.format('team-visibility')
      contents: React.createElement VisibilityComponent,
        canChange: @props.isAdmin
        visibility: @props.visibility
      onChange: @props.openChangeOrgVis
      canChange: @props.isAdmin && @hasNonEnforcedSetting(SETTINGS.permissionLevel)
      hintMessage: @hintMessage(SETTINGS.permissionLevel)

  getBCSettingsComponent: ->
    props =
      items: [@getOrgInviteRestrictionsSection(),
              @getBoardCreateVisibilityRestrictionsSection(),
              @getBoardInviteRestrictionsSection(),
              @getSlackRestrictionsSection()]
      isAdmin: @props.isAdmin
      hasBC: @props.hasBC
      billingUrl: @props.billingUrl
      hasEnterprisePromise: @props.hasEnterprisePromise
      upsellEnabled: @props.upsellEnabled

    React.createElement OrgBCSettingsComponent, props

  canChange: (settings) ->
    @props.isAdmin && @props.prefsEnabled && @hasNonEnforcedSetting(settings)

  hasNonEnforcedSetting: (settings) ->
    return true if !settings || !@props.team.getEnterprise()

    overridenSettings = @getEnforcedSettings(settings)
    overridenSettings.length < settings.length

  hintMessage: (settings) ->
    enterprise = @props.team.getEnterprise()
    return unless enterprise

    overridenSettings = @getEnforcedSettings(settings)
    if overridenSettings.length == settings.length
      t.l("setting-completely-inherited", enterpriseDisplayName: enterprise.get('displayName'))
    else if overridenSettings.length > 0
      t.l("setting-partially-inherited", enterpriseDisplayName: enterprise.get('displayName'))

  getEnforcedSettings: (settings) ->
    settings.filter (setting) =>
      prefs = @props.team.getEnterprise().get('organizationPrefs')

      return false unless prefs

      for path in setting.split('.')
        if prefs[path]?
          prefs = prefs[path]
        else
          return false

      true

  getOrgInviteRestrictionsSection: ->
    React.createElement SettingSectionComponent,
      header: t.render -> t.span ->
        t.format 'team-membership-restrictions'
        t.icon 'business-class', class: 'icon-business-class-color'
      contents: React.createElement OrgInviteRestrictionsComponent,
        isAdmin: @props.isAdmin
        hasBC: @props.hasBC
        restrictions: @props.inviteRestrictions
      onChange: @props.openChangeOrgInviteRestrictions
      canChange: @canChange(SETTINGS.orgInviteRestrict)
      hintMessage: @hintMessage(SETTINGS.orgInviteRestrict)

  getBoardCreateVisibilityRestrictionsSection: ->
     React.createElement SettingSectionComponent,
      header: t.render -> t.span ->
        t.format 'board-creation-restrictions'
        t.icon 'business-class', class: 'icon-business-class-color'
      contents: React.createElement BoardCreateVisibilityRestrictionsComponent,
        isAdmin: @props.isAdmin
        hasBC: @props.hasBC
        restrictions: @props.boardVisibilityRestrictions
      onChange: @props.openChangeBoardVisRestrictions
      canChange: @canChange(SETTINGS.boardVisibilityRestrictions)
      hintMessage: @hintMessage(SETTINGS.boardVisibilityRestrictions)

  getBoardInviteRestrictionsSection: ->
    React.createElement SettingSectionComponent,
      header: t.render -> t.span ->
        t.format 'inviting-guests-to-boards'
        t.icon 'business-class', class: 'icon-business-class-color'
      contents: React.createElement BoardInviteRestrictionsComponent,
        isAdmin: @props.isAdmin
        hasBC: @props.hasBC
        restricted: @props.externalMembersDisabled
      onChange: @props.openChangeNonOrgMemberBoardInvites
      canChange: @canChange(SETTINGS.externalMembersDisabled)
      hintMessage: @hintMessage(SETTINGS.externalMembersDisabled)

  getSlackRestrictionsSection: ->
    React.createElement SettingSectionComponent,
      header: t.render -> t.span ->
        t.format 'slack-team-restrictions'
        t.icon 'business-class', class: 'icon-business-class-color'
      contents: React.createElement SlackRestrictionsComponent,
        isAdmin: @props.isAdmin
        hasBC: @props.hasBC
        slackAssociation: @props.slackAssociation
      onChange: @props.openChangeSlackRestrictions
      canChange: @canChange()

  getSlackSection: ->
    React.createElement SlackComponent,
      isAdmin: @props.isAdmin
      hasBC: @props.hasBC
      slackAssociation: @props.slackAssociation
      deleteSlackAssociation: @props.deleteSlackAssociation
      changeSlackSelfJoin: @props.changeSlackSelfJoin



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-account-component.coffee